<section class="p-3">
  <article class="row">
    <div class="col-12 col-xl-6 mb-4">
      <h2 class="title mb-3">Manual de uso</h2>
      <div class="d-flex flex-column gap-3">
        @for (manual of manualList; track manual) {
          <p-card class="horizontal-card" (click)="openUrl(manual.url)">
            <div class="d-flex align-items-center gap-3">
              <div class="icon-container pdf-bg">
                <i class="pi pi-file-pdf text-2xl"></i>
              </div>
              <div class="flex-grow-1">
                <span class="font-bold text-lg">{{ manual.label }}</span>
                <p class="text-sm text-muted mb-0">Pulsa para abrir el PDF</p>
              </div>
              <i class="pi pi-external-link text-muted"></i>
            </div>
          </p-card>
        }
      </div>
    </div>

    <div class="col-12 col-xl-6">
      <h2 class="title mb-3">Guías</h2>
      <div class="d-flex flex-column gap-3">
        @for (guide of guideList(); track guide.label) {
          <p-card class="horizontal-card" (click)="openUrl(guide.url)">
            <div class="d-flex align-items-center gap-3">
              <div class="icon-container video-bg">
                <i class="pi pi-video text-2xl"></i>
              </div>
              <div class="flex-grow-1">
                <span class="font-bold text-lg">{{ guide.label }}</span>
                <p class="text-sm text-muted mb-0">Pulsa para ver el vídeo</p>
              </div>
              <i class="pi pi-external-link text-muted"></i>
            </div>
          </p-card>
        }
      </div>
    </div>
  </article>
  <p class="app-build-version" aria-label="Versión de la aplicación">
    {{ buildInfo.versionLabel() }}
  </p>
</section>
